import { AccuracyMatchChip } from '@/components/common/AccuracyMatchChip'
import { AccuracyTooltip } from './Tooltips'

const LowAccuracyMatchChip = () => (
  <AccuracyMatchChip
    color="warning"
    label="Low Accuracy Match"
    wrappWithTooltip={AccuracyTooltip}
  />
)

export default LowAccuracyMatchChip
